module.exports = {"COMMONS_GENERAL":{"MODAL":{"CLOSE":"Close"}}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en.json
// module id = ./src/i18n/en.json
// module chunks = widget-7.1.6